import React from "react";
import { useSitePlanningStagesQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const SitePlanningStageSelect = (props) => {
    const query = useSitePlanningStagesQueryQuery();
    return <GraphQlSelect {...props} queryResult={query} labelField="label"/>;
}
